import { render } from "./SideBarUser.vue?vue&type=template&id=4b6909d7"
import script from "./SideBarUser.vue?vue&type=script&lang=js"
export * from "./SideBarUser.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__